import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { Star } from "@phosphor-icons/react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.1 },
  }),
};

function ReviewCard({ review }) {
  return (
    <div
      className="flex-shrink-0 w-[340px] p-8 mx-3 border"
      style={{ borderColor: '#2A2A2A', backgroundColor: '#141414' }}
    >
      <div className="flex gap-1 mb-4">
        {Array.from({ length: review.rating }).map((_, i) => (
          <Star key={i} size={14} weight="fill" style={{ color: '#FF5A36' }} />
        ))}
      </div>
      <p className="font-body text-sm leading-relaxed mb-6" style={{ color: '#9A9A9A' }}>
        "{review.text}"
      </p>
      <div className="flex items-center justify-between">
        <span className="font-accent text-sm font-semibold" style={{ color: '#F0EDE5' }}>
          {review.name}
        </span>
        <span className="font-accent text-xs tracking-wide" style={{ color: '#A8C6C3' }}>
          {review.product}
        </span>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    async function fetchReviews() {
      try {
        const res = await axios.get(`${API}/reviews`);
        setReviews(res.data);
      } catch (err) {
        console.error("Failed to fetch reviews:", err);
      }
    }
    fetchReviews();
  }, []);

  return (
    <section id="reviews" className="py-24 lg:py-32" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-16">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="text-center"
        >
          <motion.p
            variants={fadeUp}
            custom={0}
            className="font-accent text-sm tracking-[0.25em] uppercase mb-4"
            style={{ color: '#FF5A36' }}
          >
            Real People. Real Results.
          </motion.p>
          <motion.h2
            variants={fadeUp}
            custom={1}
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight"
            style={{ color: '#F0EDE5' }}
          >
            What They're Saying
          </motion.h2>
        </motion.div>
      </div>

      {reviews.length > 0 && (
        <Marquee
          speed={40}
          gradient={true}
          gradientColor="#0C0C0C"
          gradientWidth={80}
          pauseOnHover={true}
          data-testid="testimonials-marquee"
        >
          {reviews.map((review, index) => (
            <ReviewCard key={index} review={review} />
          ))}
        </Marquee>
      )}
    </section>
  );
}
